import pgrid from '@bingads-webui-component-legacy/github/modules/projection-grid/module/projection-grid';
import Backbone from 'backbone';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');

export default class ErrorGrid extends Backbone.View {
  initialize(options) {
    this.rowTemplate = options.rowTemplate;
    this.entityType = options.entityType;
    this.errors = options.errors;
    this.colClass = ['error-grid-col'];
    this.i18nKeys = options.i18nKeys;
  }

  columnConfiguration() {
    const errorGridColumns = [{
      name: 'Extension',
      title: i18n.getString('ErrorGrid_AdExtension_Column'),
      template: (locals) => {
        return this.rowTemplate({
          data: locals.value,
          i18n,
        });
      },
      bodyClasses: [this.colClass, 'error-grid_Extension'],
    }, {
      name: 'Error',
      title: i18n.getString('ErrorGrid_Error_Column'),
      bodyClasses: [this.colClass, 'error-grid_Error'],
      template: (locals) => {
        return locals.value;
      },
    }];

    if (this.entityType === 'campaign' || this.entityType === 'adgroup') {
      errorGridColumns.unshift({
        name: 'Entity',
        title: this.entityType === 'campaign' ?
          i18n.getString(this.i18nKeys && this.i18nKeys.ErrorGridEntityCampaignColumn ? this.i18nKeys.ErrorGridEntityCampaignColumn : 'ErrorGrid_Entity_Campaign_Column') :
          i18n.getString(this.i18nKeys && this.i18nKeys.ErrorGridEntityAdgroupColumn ? this.i18nKeys.ErrorGridEntityAdgroupColumn : 'ErrorGrid_Entity_Adgroup_Column'),
        template: (locals) => {
          if (this.entityType === 'adgroup') {
            return i18n.get('Error_Grid_Adgroup_Name', {
              campaignName: locals.value.campaignName,
              adgroupName: locals.value.adgroupName,
            });
          }
          return locals.value.campaignName;
        },
        bodyClasses: [this.colClass, 'error-grid_Entity', 'truncated'],
      });
    }

    return errorGridColumns;
  }

  render() {
    this.gridView = pgrid.factory({
      vnext: true,
    })
      .create({
        tableClasses: ['table', 'table-bordered'],
        dataSource: {
          type: 'memory',
          data: this.errors,
          primaryKey: i18n.getString('ErrorGrid_Column_Header_Campaign'),
        },
        columns: this.columnConfiguration(),
        scrolling: {
          virtualized: true,
          header: 'fixed',
        },
      }).gridView;

    this.$el.html(this.gridView.render().$el);
    return this;
  }

  removeGrid() {
    this.$el.empty();
  }
}
